'use client';

import { cn } from '@/lib/ui/cn';

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  className?: string;
}

/**
 * Visual progress indicator for the wizard flow.
 * A simple horizontal bar that fills from left to right based on progress.
 */
export function ProgressBar({
  currentStep,
  totalSteps,
  className,
}: ProgressBarProps) {
  // Calculate progress percentage
  const progress = totalSteps > 0 ? (currentStep / totalSteps) * 100 : 0;

  return (
    <div
      className={cn('h-1.5 w-full overflow-hidden rounded-full', className)}
      style={{ backgroundColor: '#C9C4BD' }}
    >
      <div
        className='h-full rounded-full transition-all duration-300 ease-out'
        style={{ width: `${progress}%`, backgroundColor: '#1B2130' }}
      />
    </div>
  );
}
